var map = {
	"./Amex.svg": 1479,
	"./Apple.svg": 1480,
	"./Arrow-Coverage-Dark.svg": 1481,
	"./Arrow-Coverage-Light.svg": 1482,
	"./Arrow-Coverage.svg": 1483,
	"./Arrow-Element.svg": 1484,
	"./Arrow-Macro-Light.svg": 1485,
	"./Arrow-Macro.svg": 1486,
	"./Arrow-Micro-Dark.svg": 1487,
	"./Arrow-Micro.svg": 1488,
	"./Auth.svg": 1489,
	"./Close-Dark.svg": 1490,
	"./Close-Light.svg": 1491,
	"./Coverage-Dark.svg": 1492,
	"./Coverage-Light.svg": 1493,
	"./Credit-Card.svg": 1494,
	"./Data-Dark-16.svg": 1495,
	"./Data-Dark.svg": 1496,
	"./Data-Light-16.svg": 1497,
	"./Data-Light.svg": 1498,
	"./Down-Arrow.svg": 1499,
	"./Facebook-Original.svg": 1500,
	"./Footer-Amex.svg": 1501,
	"./Footer-Arrow-Close.svg": 1502,
	"./Footer-Arrow-Open.svg": 1503,
	"./Footer-Facebook.svg": 1504,
	"./Footer-Instagram.svg": 1505,
	"./Footer-Linkedin.svg": 1506,
	"./Footer-MasterCard.svg": 1507,
	"./Footer-Paypal.svg": 1508,
	"./Footer-Twitter.svg": 1509,
	"./Footer-VK.svg": 1510,
	"./Footer-Visa.svg": 1511,
	"./Footer-X.svg": 1512,
	"./GooglePlayStore.svg": 1513,
	"./ID.svg": 1514,
	"./Information.svg": 1515,
	"./Inline-American-Express.svg": 1516,
	"./Inline-MasterCard.svg": 1517,
	"./Inline-Unionpay.svg": 1518,
	"./Inline-Visa.svg": 1519,
	"./Input-Search-Dark.svg": 1520,
	"./Input-Search-Light.svg": 1521,
	"./Linkedin-Light.svg": 1522,
	"./Log-out-red.svg": 1523,
	"./Log-out.svg": 1524,
	"./Logo.svg": 1525,
	"./Manual-Install.svg": 1526,
	"./Mastercard.svg": 1527,
	"./PayPal.svg": 1528,
	"./Plus.svg": 1529,
	"./Price-Dark.svg": 1530,
	"./Price-Light.svg": 1531,
	"./QR.svg": 1532,
	"./Readonly-Input-Lock.svg": 1533,
	"./Saved-Amex.svg": 1534,
	"./Saved-MasterCard.svg": 1535,
	"./Saved-Visa.svg": 1536,
	"./Search.svg": 1537,
	"./Secure-Auth.svg": 1538,
	"./Secure-W.svg": 1539,
	"./Secure.svg": 1540,
	"./Share.svg": 1541,
	"./Star_color.svg": 1542,
	"./Store-Active-Dark.svg": 1543,
	"./Store-Active-Light.svg": 1544,
	"./Store-B.svg": 1545,
	"./Store-Inactive.svg": 1546,
	"./Store-W.svg": 1547,
	"./Store.svg": 1548,
	"./Success.svg": 1549,
	"./Trash.svg": 1550,
	"./Twitter-Original.svg": 1551,
	"./User-Active-Dark.svg": 1552,
	"./User-Active-Light.svg": 1553,
	"./User-Inactive.svg": 1554,
	"./Validity-Dark.svg": 1555,
	"./Validity-Light.svg": 1556,
	"./Visa.svg": 1557,
	"./What-is-This.svg": 1558,
	"./copy.svg": 1559,
	"./eSIM-Active-Dark.svg": 1560,
	"./eSIM-Active-Light.svg": 1561,
	"./eSIM-Dark.svg": 1562,
	"./eSIM-Inactive.svg": 1563,
	"./eSIM-Light.svg": 1564,
	"./email.svg": 1565,
	"./facebook.svg": 1566,
	"./ic_add-card.svg": 1567,
	"./ic_airmoney_macro.svg": 1568,
	"./ic_airmoney_micro.svg": 1569,
	"./ic_airmoney_pay.svg": 1570,
	"./ic_airmoney_payment-method.svg": 1571,
	"./ic_alipay_payment-method-dark.svg": 1572,
	"./ic_alipay_payment-method-light.svg": 1573,
	"./ic_amex.svg": 1574,
	"./ic_apple-dark.svg": 1575,
	"./ic_apple-light.svg": 1576,
	"./ic_apple-pay_payment-method.svg": 1577,
	"./ic_arrow_slider_active_Light.svg": 1578,
	"./ic_arrow_slider_inactive_Light.svg": 1579,
	"./ic_back_header-dark.svg": 1580,
	"./ic_back_header-light.svg": 1581,
	"./ic_banner_refeere.svg": 1582,
	"./ic_banner_referrer.svg": 1583,
	"./ic_bill_to_org_payment-method-light.svg": 1584,
	"./ic_calls.svg": 1585,
	"./ic_checkbox_active.svg": 1586,
	"./ic_checkbox_inactive.svg": 1587,
	"./ic_chevron-right.svg": 1588,
	"./ic_chip.svg": 1589,
	"./ic_clear.svg": 1590,
	"./ic_close_white.svg": 1591,
	"./ic_copy.svg": 1592,
	"./ic_coverage.svg": 1593,
	"./ic_credit-card_payment-method-dark.svg": 1594,
	"./ic_credit-card_payment-method-light.svg": 1595,
	"./ic_data.svg": 1596,
	"./ic_delete_white.svg": 1597,
	"./ic_discount-code.svg": 1598,
	"./ic_edit_white.svg": 1599,
	"./ic_esim.svg": 1600,
	"./ic_expire.svg": 1601,
	"./ic_fup.svg": 1602,
	"./ic_google-pay.svg": 1603,
	"./ic_google-pay_payment-method.svg": 1604,
	"./ic_google.svg": 1605,
	"./ic_help_center.svg": 1606,
	"./ic_install.svg": 1607,
	"./ic_jcb.svg": 1608,
	"./ic_logout.svg": 1609,
	"./ic_long-back-arrow.svg": 863,
	"./ic_manual_install.svg": 1610,
	"./ic_mastercard.svg": 1611,
	"./ic_notification.svg": 1612,
	"./ic_package.svg": 1613,
	"./ic_paypal_payment-method-dark.svg": 1614,
	"./ic_paypal_payment-method-light.svg": 1615,
	"./ic_play.svg": 1616,
	"./ic_price.svg": 1617,
	"./ic_price_v2.svg": 1618,
	"./ic_qrcode_install.svg": 1619,
	"./ic_routing.svg": 1620,
	"./ic_screenshot.svg": 1621,
	"./ic_sms.svg": 1622,
	"./ic_statistic.svg": 1623,
	"./ic_store_header.svg": 1624,
	"./ic_stripe.svg": 835,
	"./ic_subscription.svg": 1625,
	"./ic_success.svg": 1626,
	"./ic_success_banner.svg": 1627,
	"./ic_success_order-completed.svg": 1628,
	"./ic_telegram.svg": 1629,
	"./ic_tips.svg": 1630,
	"./ic_unionpay.svg": 1631,
	"./ic_validity.svg": 1632,
	"./ic_visa.svg": 1633,
	"./ic_visa_payment-method.svg": 1634,
	"./ic_visa_saved-card.svg": 1635,
	"./ic_whatsapp.svg": 1636,
	"./icon-ekyc-detail-card-info.svg": 1637,
	"./icon-ekyc-detail-driver-license.svg": 1638,
	"./icon-ekyc-detail-faq-arrow.svg": 1639,
	"./icon-ekyc-detail-finger-print.svg": 1640,
	"./icon-ekyc-detail-identity-card.svg": 1641,
	"./icon-ekyc-detail-jumio.svg": 1642,
	"./icon-ekyc-detail-passport.svg": 1643,
	"./icon-esim-detail-copy-dark.svg": 1644,
	"./icon-esim-detail-copy-light.svg": 1645,
	"./icon-esim-detail-coverage-arrow-dark.svg": 1646,
	"./icon-esim-detail-coverage-arrow-light.svg": 1647,
	"./icon-esim-detail-error-text-field-dark.svg": 1648,
	"./icon-esim-detail-error-text-field-light.svg": 1649,
	"./icon-header-airmoney.svg": 1650,
	"./icon-header-arrow-close.svg": 1651,
	"./icon-header-language.svg": 1652,
	"./icon-header-myesim.svg": 1653,
	"./icon-header-profile.svg": 1654,
	"./icon-header-store.svg": 1655,
	"./icon-hero-rating-appstore.svg": 1656,
	"./icon-hero-rating-googleplay.svg": 1657,
	"./icon-homepage-country-arrow-close.svg": 1658,
	"./icon-homepage-country-arrow-open.svg": 1659,
	"./icon-homepage-country-data-dark-16.svg": 1660,
	"./icon-homepage-country-data-dark-22.svg": 1661,
	"./icon-homepage-country-data-light-16.svg": 1662,
	"./icon-homepage-country-data-light-22.svg": 1663,
	"./icon-info-general-dark.svg": 1664,
	"./icon-info-general-light.svg": 1665,
	"./icon-mob-website-expansion-item-arrow.svg": 1666,
	"./icon-myesims-checklist.svg": 1667,
	"./icon-myesims-nosign.svg": 1668,
	"./icon-myesims-trash-slash.svg": 1669,
	"./icon-myesims-wifi-exclamationmark.svg": 1670,
	"./icon-orders-billed-to.svg": 1671,
	"./icon-package-3g-light.svg": 836,
	"./icon-package-4g-light.svg": 837,
	"./icon-package-5g-light.svg": 838,
	"./icon-package-activation-policy-light.svg": 839,
	"./icon-package-arrow-general-light.svg": 840,
	"./icon-package-calling-credit-light.svg": 841,
	"./icon-package-coverage-dark.svg": 1672,
	"./icon-package-coverage-light.svg": 842,
	"./icon-package-ekyc-micro-light.svg": 843,
	"./icon-package-ekyc-restriction-light.svg": 844,
	"./icon-package-ekyc-validation-light.svg": 845,
	"./icon-package-fup-dark.svg": 1673,
	"./icon-package-fup-light.svg": 846,
	"./icon-package-info-general-light.svg": 847,
	"./icon-package-lte-light.svg": 848,
	"./icon-package-network-light.svg": 849,
	"./icon-package-plan-type-light.svg": 850,
	"./icon-package-price-dark.svg": 1674,
	"./icon-package-price-light.svg": 851,
	"./icon-package-supported-arrow-dark.svg": 1675,
	"./icon-package-supported-arrow-light.svg": 852,
	"./icon-package-topup-option-light.svg": 853,
	"./icon-package-validity-dark.svg": 1676,
	"./icon-package-validity-light.svg": 854,
	"./icon-partner-with-us-breadcrumb-arrow.svg": 1677,
	"./icon-password-hidden-error.svg": 1678,
	"./icon-password-hidden.svg": 1679,
	"./icon-password-visible-error.svg": 1680,
	"./icon-password-visible.svg": 1681,
	"./icon-search-clear.svg": 1682,
	"./icon-search.svg": 1683,
	"./icon-unlimited-dark.svg": 1684,
	"./icon-unlimited-light.svg": 1685,
	"./icon-website-expansion-content-box-bg-sm.svg": 1686,
	"./icon-website-expansion-content-box-bg.svg": 1687,
	"./mail.svg": 1688,
	"./settings_button.svg": 1689,
	"./tabs-Airmoney.svg": 1690,
	"./tabs-Credit-Card.svg": 1691,
	"./tabs-PayPal.svg": 1692,
	"./telegram.svg": 1693,
	"./tick-light.svg": 1694,
	"./twitter.svg": 1695,
	"./whatsapp.svg": 1696
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1478;